export default __webpack_public_path__ + "static/staff-presentation_by-79fa6f98ba922ed5d50ac60352df01f9.png";